export const MAX_POSITION_VALUE = 250;

export const MIN_POSITION_VALUE = 1;
